import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import './RegisterForm.css';
import { toast, ToastContainer } from "react-toastify";
import Corner from "../assets/corner.png";

const RegisterForm = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [attending, setAttending] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    //const [guests, setGuests] = useState(0);
    const [plusOneName, setPlusOneName] = useState('');
    const [mealChoice, setMealChoice] = useState('');
    const [dietary_requirements, setDietaryRestrictions] = useState('');
    const [additional_remarks, setMessage] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [guests, setInputs] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {


            await api.post('/api/rsvp/register', {
                name,
                status: 'Pending',
                email,
                attending,
                guests,
                dietary_requirements,
                additional_remarks
                // Default to 'pending'
            });
            toast.success("RSVP submitted successfully!");

            // Redirect to homepage or another page after successful registration
        } catch (err) {
            // console.error(err);
            setError('Failed to create RSVP.')
            setSubmitting(false)
        }
    };
    const handleChange = (e) => {
        setAttending(e.target.checked);
    };



    const handleInputChange = (e, id, field) => {
        const { type, value, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;

        setInputs(guests.map(input =>
            input.id === id ? { ...input, [field]: newValue } : input
        ));
    };



    // Function to add a new set of inputs
    const handleAddInput = () => {
        setInputs([...guests, { id: Date.now(), input1: '', input2: '', input3: '' }]);
    };

    // Function to remove a set of inputs
    const handleRemoveInput = (id) => {
        setInputs(guests.filter(input => input.id !== id));
    };

    return (<div>
        <img src={Corner} className="corner top-left" alt="" />
        <img src={Corner} className="corner top-right" alt="" />
        <img src={Corner} className="corner bottom-left" alt="" />
        <img src={Corner} className="corner bottom-right" alt="" />
        <div className="container-fluid d-flex justify-content-center align-items-center">

            <div className="col-12 col-md-12 col-lg-12 col-xl-12" >
                <div className="card p-1 shadow rounded-4" >
                    <h2 className="text-center mb-2">RSVP</h2>

                    {error && <div className="alert alert-danger">{error}</div>}

                    <form onSubmit={handleSubmit}
                        className='d-flex flex-column align-items-center'>
                        <div className="mb-3 w-75">
                            <p>Please join us as we celebrate our wedding on June 18th 2026 in Gauteng, South Africa.</p>
                            <p>All wedding details, including the venue and itinerary, will be sent to the email address provided in the RSVP below.</p>
                            <p>Only one RSVP is required per family because additional guests may be added within the same RSVP.</p>
                            <p>We kindly ask that you complete the RSVP form below as soon as possible.</p>
                        </div>
                        <div className="mb-3 w-75 mx-auto">
                            <label htmlFor="name" className="form-label">Name<span className="text-danger">*</span>
                            </label>
                            <input

                                type="name"
                                className="form-control"
                                id="name"
                                placeholder="Enter Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3 w-75">
                            <label htmlFor="email" className="form-label">
                                Email address<span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                id="email"
                                placeholder="Enter Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3 w-75">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="attending"
                                placeholder="Attending?"
                                checked={attending}
                                // onChange={handleChange}
                                onChange={(e) => setAttending(e.target.checked)}

                            />
                            <label htmlFor="attending" className="form-label">Attending</label>
                        </div>

                        <div className="mb-3 w-75">
                            <h3>Guests</h3>
                            <p style={{ textAlign: "justify" }}>
                                Please add any guests you would like to bring along with you to the wedding.<br></br>
                            </p>
                            {guests.map((input, index) => (
                                <div key={input.id} className="form-group row mb-3">

                                    {/* Name Input */}
                                    <div className="col-12  ">
                                        <label htmlFor={`input-${input.id}-1`} className="form-label">
                                            Name<span className="text-danger">*</span></label>
                                        <input
                                            id={`input-${input.id}-1`}
                                            className="form-control"
                                            type="text"
                                            value={input.input1}
                                            onChange={(e) => handleInputChange(e, input.id, 'input1')}
                                            placeholder="Enter Name"
                                            required
                                        />
                                    </div>

                                    {/* Child Checkbox */}
                                    <div className="col-6 d-flex align-items-center  ">
                                        {/* <div className=" col-12"> */}
                                        <input
                                            className="form-check-input "
                                            type="checkbox"
                                            id={`input-${input.id}-2`}
                                            checked={input.input2}  // use checked for checkbox
                                            onChange={(e) => handleInputChange(e, input.id, 'input2')}
                                        />
                                        <label htmlFor={`input-${input.id}-2`} className="form-label mb-0">
                                            Under 12?
                                        </label>
                                        {/* </div> */}
                                    </div>

                                    {/* Remove Button */}
                                    <div className="col-6  d-flex justify-content-end">
                                        <button
                                            type="button" onClick={() => handleRemoveInput(input.id)} className="btn w-80 mt-4" > Remove </button>

                                    </div>

                                </div>
                            ))}

                            <button
                                type="button"
                                onClick={handleAddInput}
                                className="btn btn-primary mb-3"
                            >
                                Add a Guest
                            </button>
                        </div>

                        <div className="mb-2 w-75">
                            <label htmlFor="mealChoice" className="form-label">Food Restrictions</label>
                            <input
                                type="mealChoice"
                                className="form-control"
                                id="mealChoice"
                                placeholder="Enter Food Restrictions"
                                value={dietary_requirements}
                                onChange={(e) => setDietaryRestrictions(e.target.value)}
                            // required
                            />
                        </div>
                        <div className="mb-2 w-75">
                            <label htmlFor="message" className="form-label">Message</label>
                            <textarea
                                type="text"
                                className="form-control"
                                id="message"
                                placeholder="Enter message if you'd like"
                                value={additional_remarks}
                                onChange={(e) => setMessage(e.target.value)}
                            // required
                            />
                        </div>
                        <button type="submit" className="btn w-80 mb-3" disabled={submitting}>Submit</button>
                    </form>
                </div>
            </div >
        </div >
        <ToastContainer
            position="top-right"
            autoClose={2000}
            onClose={() => {
                navigate('/');
            }}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />
    </div >
    );
};
export default RegisterForm;
